import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { JobRequestService } from "../../../../services/business/job-request.service";
import { EditJobRequestModel } from "../../../../models/inModels/jobRequest";
import { StorageService } from "../../../../services/system/storage.service";
import { BusinessService as BusinessCategoryService } from "../../../../services/business/business-category.service";
import { EditJobAdmition, JobAdmition } from '../../../../models/inModels/JobAdmition';
import { JobAdmitionService } from '../../../../services/business/job-admition.service';
import { DataTable } from "primeng/components/datatable/datatable";
import { NotificationContentType } from '../../../../models/inModels/MessageModel';
import { SelectItem, LazyLoadEvent, Message, ConfirmationService } from 'primeng/api';

@Component({
	selector: 'app-job-requests-edit',
	templateUrl: './job-requests-edit.component.html',
	styleUrls: ['./job-requests-edit.component.css']
})
export class JobRequestsEditComponent implements OnInit {

	id;
	model: EditJobRequestModel;
	loading: boolean;
	messages: Message[];
	error: Message[];
	categories: SelectItem[];
	selectedCategory;
	//Admissions code 
	jobAdmition: JobAdmition[];
	rows: SelectItem[];
	selectedAdmission;
	selectedRows: number;
	filteredRecords: number;
	filters;
	rowEvent: LazyLoadEvent;
	totalRecords: number;
	sendAllDialog = false;
	contentId: number;
	contentType: NotificationContentType;

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private service: JobRequestService,
		public businessService: BusinessCategoryService,
		private admitionService: JobAdmitionService,
		private confirmationService: ConfirmationService) {
		this.loading = true;
		this.rows = [];
		this.rows.push({ label: '10', value: 10 });
		this.rows.push({ label: '25', value: 25 });
		this.rows.push({ label: '50', value: 50 });
		this.selectedRows = 10;
		this.id = this.route.snapshot.paramMap.get('Id');
	}

	ngOnInit() {
		this.getJobRequest();

	}

	changeRows(event): void {
		this.load(this.rowEvent);
	}

	reset(dt: DataTable, gb: HTMLInputElement) {
		dt.reset();
	}

	load(event: LazyLoadEvent): void {
		this.loading = true;
		event.rows = this.selectedRows;
		console.log(event);
		event.filters['RequestId'] = { value: this.id, matchMode: 'equals' };
		this.rowEvent = event;
		this.admitionService.search(event).then(
			dataPager => {
				this.jobAdmition = dataPager.Data;
				this.filteredRecords = dataPager.FilteredRecords;
				this.totalRecords = dataPager.TotalRecords;
				this.loading = false;
			},
			error => {
				this.loading = false;
				console.log(error);
				this.jobAdmition = [];
				this.totalRecords = 0;
				this.filteredRecords = 0;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error })
			}
		);
	}

	getJobRequest() {
		this.loading = true;
		this.service.get(this.id).then(
			result => {
				this.model = new EditJobRequestModel(result);
				this.selectedCategory = { value: result.CategoryId, label: result.Category };
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	initCategoryDropDown(event) {
		this.businessService.getDropdown(event).then(
			x => {
				this.categories = x;
			},
			error => {
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	setCategory(): void {
		this.model.categoryId = this.selectedCategory.value;
	}

	goBack(): void {
		this.router.navigate(['/requests']);
	}

	save() {
		this.loading = true;
		this.service.update(this.model).then(
			result => {
				this.loading = false;
				this.model = new EditJobRequestModel(result);
				this.error = [];
				this.error.push({ severity: 'success', summary: 'Success', detail: "Request saved" });
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			});
	}

	connect(jobAdmition: JobAdmition) {
		console.log(jobAdmition);
		this.confirmationService.confirm({
			message: `Are you sure you want to connect ${jobAdmition.FullName} to this job?`,
			header: 'Confirmation',
			icon: 'fa fa-user-plus',
			accept: () => {
				this.loading = true;
				this.service.connect(this.id, jobAdmition.Id).then(
					result => {
						this.loading = false;
						this.getJobRequest();
						this.load(this.rowEvent);
					},
					error => {
						this.loading = false;
						this.error = [];
						this.error.push({ severity: 'error', summary: 'Error', detail: error });
					});
			}
		});
	}

	disconnect(jobAdmition: JobAdmition) {
		console.log(jobAdmition);
		this.confirmationService.confirm({
			message: `Are you sure you want to disconnect ${jobAdmition.FullName} from this job?`,
			header: 'Confirmation',
			icon: 'fa fa-user-times',
			accept: () => {
				this.loading = true;
				this.service.disconnect(this.id, jobAdmition.Id).then(
					result => {
						this.loading = false;
						this.getJobRequest();
						this.load(this.rowEvent);
					},
					error => {
						this.loading = false;
						this.error = [];
						this.error.push({ severity: 'error', summary: 'Error', detail: error });
					});
			}
		});
	}

	delete(jobAdmition: JobAdmition) {
		console.log(jobAdmition);
		this.confirmationService.confirm({
			message: `Are you sure you want to delete ${jobAdmition.CompanyName}'s admition?`,
			header: 'Confirmation',
			icon: 'fa fa-trash-o',
			accept: () => {
				this.loading = true;
				this.admitionService.delete(jobAdmition.Id).then(
					result => {
						this.loading = false;
						this.getJobRequest();
						this.load(this.rowEvent);
					},
					error => {
						this.loading = false;
						this.error = [];
						this.error.push({ severity: 'error', summary: 'Error', detail: error });
					});
			}
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/components/sales/job-requests/job-requests-edit/job-requests-edit.component.ts